/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * User events for tracking referrals and mobile users
 * @export
 * @interface UpdateUserRequestBodyEvents
 */
export interface UpdateUserRequestBodyEvents {
    /**
     * Hash ID of the user who referred this user
     * @type {string}
     * @memberof UpdateUserRequestBodyEvents
     */
    referrer?: string;
    /**
     * Whether the user is on mobile
     * @type {boolean}
     * @memberof UpdateUserRequestBodyEvents
     */
    isMobileUser?: boolean;
}

/**
 * Check if a given object implements the UpdateUserRequestBodyEvents interface.
 */
export function instanceOfUpdateUserRequestBodyEvents(value: object): value is UpdateUserRequestBodyEvents {
    let isInstance = true;

    return isInstance;
}

export function UpdateUserRequestBodyEventsFromJSON(json: any): UpdateUserRequestBodyEvents {
    return UpdateUserRequestBodyEventsFromJSONTyped(json, false);
}

export function UpdateUserRequestBodyEventsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserRequestBodyEvents {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'referrer': !exists(json, 'referrer') ? undefined : json['referrer'],
        'isMobileUser': !exists(json, 'is_mobile_user') ? undefined : json['is_mobile_user'],
    };
}

export function UpdateUserRequestBodyEventsToJSON(value?: UpdateUserRequestBodyEvents | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'referrer': value.referrer,
        'is_mobile_user': value.isMobileUser,
    };
}

